<template>
  <div>
    <el-dialog :visible.sync="open" title="Connect DAPP" width="6.5rem">
      <p class="des">Wells of your choose, the benefit ratio distributed to DAPP is:</p>
      <div class="table_box">
        <el-table :data="tableData">
          <el-table-column type="index" label="No." />
          <el-table-column property="nickname" label="Well Name" />
          <el-table-column property="ratio" label="Benefit ratio" align="right" >
            <template slot-scope="{row}">
              {{ row.ratio }}%
            </template>
          </el-table-column>
        </el-table>
        <p class="fr total">Total: <span>{{totalVal}}%</span></p>
      </div>

      <el-form :model="form">
        <el-form-item
          label="Verification Code"
          prop="code"
          :rules="{
            required: true,
            message: 'Please input Verification Code',
            trigger: 'blur',
          }"
        >
          <el-input v-model="form.code" placeholder="Please enter the verifcation code provided by DAPP" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="open = false">Cancel</el-button>
        <el-button type="primary" @click="handleSubmite" :loading="btnloading"> Confirm </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      form: {
        code: undefined,
      },
      ids: [],
      tableData: [],
      totalVal:'',
      producerContract: undefined,
      producerAddress: undefined,
      otterAccount:'0x10da0cdaf4ad7b6667e1a4aad4083aa4b7139cbb',
      dappID:undefined,
      btnloading:false,
    };
  },
  methods: {
    getabi() {
      this.getAbi("OilProducer").then((res) => {
        this.producerContract = new web3.eth.Contract(res.data.abi, res.data.address);
        this.producerAddress = res.data.address;
      });
    },
    generateId(wellID) {
      return web3.utils.padRight(web3.utils.toHex(wellID), 64);
    },
    show(list,item) {
      this.otterAccount = item.account
      this.dappID = item.dappID
      this.tableData = []
      list.forEach(item => {
        item.beneficiaries.forEach(sub_item => {
          if(sub_item.tnEthAccount.toLowerCase() === this.otterAccount.toLowerCase()){
            this.ids.push(web3.utils.padRight(web3.utils.toHex(item.wellID), 64))
            this.tableData.push({nickname:item.nickname,wellID:item.wellID,...sub_item})
          }
        })
      })
      this.totalVal = this.tableData.reduce((pre,cur) => {
        return pre + Number(cur.ratio)
      },0)
      this.getabi();
      this.open = true;
    },

    handleSubmite() {
      this.btnloading = true
      let code = web3.utils.padRight(web3.utils.toHex(this.form.code), 64)
      const tx_builder = this.producerContract.methods["link"](
        this.ids,
        code,
        this.dappID
      );
      const encoded_tx = tx_builder.encodeABI();

      let json = {
        gas: this.$store.getters.gas,
        from: this.$store.getters.metaMaskObj.account,
        to: this.producerAddress,
        value: 0,
        data: encoded_tx,
      };
      web3.eth
        .sendTransaction(json)
        .then((res) => {
          this.$message.success("Submitted successfully！");
          this.btnloading = false
          this.form.code = undefined
          this.open = false;
        })
        .catch((error) => {
          this.$message.error("operation failed");
          this.btnloading = false
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_box {
  overflow: hidden;
}
.des {
  font-size: 0.18rem;
  font-family: Roboto-Bold, Roboto;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.28rem;
  margin-bottom: 0.16rem;
}
.total {
  font-size: 0.18rem;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.28rem;
  margin-top: 0.16rem;
  span {
    color: #000;
  }
}
</style>
